import type { ReactNode } from 'react'

import styles from './Badge.module.css'

export type Tone = 'good' | 'bad' | 'warn' | 'neutral' | 'accent'

export function Badge({ tone, small, children }: { tone: Tone; small?: boolean; children: ReactNode }) {
  return <span className={`${styles.badge} ${styles[tone]} ${small ? styles.small : ''}`}>{children}</span>
}
